"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _wechatShare = _interopRequireDefault(require("./wechatShare"));

var assign = require('object-assign');

/**
 * 微信二次分享
 * @param  {Object} shareContent 分享参数对象
 * @shareContent {String} shareContent.title 分享标题
 * @shareContent {String} shareContent.desc 分享描述
 * @shareContent {String} shareContent.link 分享链接 默认为当前页面地址
 * @shareContent {String} shareContent.imgUrl 分享卡片封面图地址
 * @param  {Boolean} options.debug 是否启用调试
 * @param  {String} options.appId 微信公众号对应的唯一标识
 */
function wxShare() {
  var shareContent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var shareConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0, _wechatShare["default"])(shareContent, assign({}, shareConfig, {
    SDKUrl: 'https://s2.pstatp.com/js/weixin_jssdk.js?ver=0203',
    SDKUrl140: 'https://s2.pstatp.com/toutiao/js/weixin_jssdk_140.js',
    signatureAPI: '//open.snssdk.com/jssdk_signature/'
  }));
}

wxShare["default"] = wxShare;
var _default = wxShare;
exports["default"] = _default;
module.exports = exports["default"];